export default "__VITE_ASSET__Daq_GDCW__"